import type { Ref } from "react";
import { AddDocument } from "@components/documents/FinancialDocumentList/AddDocument";
import { Button } from "@design-system/Button/Button";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import styles from "./DocumentRetrievalTaskBody.module.scss";

interface Props {
    uploadAllButtonRef: Ref<HTMLButtonElement>;
    hasUnverifiedDocs: boolean;
    isCompleted: boolean;
    isAllResolved: boolean;
    isViewOnly: boolean;
    markCompleteTooltip: string;
    attachedDocumentIds: number[];
    attachDocument: (documentId: number) => void;
    attachDocuments: (documentIds: number[]) => void;
    onReviewUnmatched: () => void;
    onMarkComplete: () => void;
    onMarkIncomplete: () => void;
}

export function DocumentRetrievalDefaultActions({
    uploadAllButtonRef,
    hasUnverifiedDocs,
    isCompleted,
    isAllResolved,
    isViewOnly,
    markCompleteTooltip,
    attachedDocumentIds,
    attachDocument,
    attachDocuments,
    onReviewUnmatched,
    onMarkComplete,
    onMarkIncomplete,
}: Readonly<Props>) {
    return (
        <div className={styles.commandBarActions}>
            {hasUnverifiedDocs && (
                <Button variant="primary" size="md" onClick={onReviewUnmatched}>
                    Review unmatched
                </Button>
            )}
            <AddDocument
                trigger={
                    <Button
                        ref={uploadAllButtonRef}
                        variant="primary"
                        size="md"
                        rightIcon={
                            <span data-slot-box="">
                                <Shortcut keys="mod+enter" />
                            </span>
                        }
                    >
                        Upload all
                    </Button>
                }
                attachDocument={attachDocument}
                attachDocuments={attachDocuments}
                attachedDocumentIds={attachedDocumentIds}
            />
            {isCompleted ? (
                <Tooltip content={markCompleteTooltip}>
                    <Button
                        variant="primary"
                        size="md"
                        disabled={isViewOnly}
                        onClick={onMarkIncomplete}
                    >
                        Mark incomplete
                    </Button>
                </Tooltip>
            ) : (
                isAllResolved && (
                    <Tooltip content={markCompleteTooltip}>
                        <Button
                            variant="primary"
                            size="md"
                            disabled={isViewOnly}
                            onClick={onMarkComplete}
                        >
                            Mark complete
                        </Button>
                    </Tooltip>
                )
            )}
        </div>
    );
}
